import React from 'react';
import { Button, Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';
import PropTypes from 'prop-types';
import './index.css';
import { MODAL_TYPE_FAILURE, MODAL_TYPE_SUCCESS } from '../../../constants';

const CorporateModal = (props) => {
    let modalFooter = (props.modalType === MODAL_TYPE_FAILURE || props.modalType === MODAL_TYPE_SUCCESS) ?
        <ModalFooter>
            <Button color="primary" onClick={props.modalClosed}>OK</Button>
        </ModalFooter>
        :
        '';
    return (

        <Modal isOpen={props.toShow} toggle={props.modalClosed} centered>
            <ModalHeader toggle={props.modalClosed}>{props.title}</ModalHeader>
            <ModalBody className={(props.styleType) ? props.styleType : ''}>
                {props.body}
            </ModalBody>

            {modalFooter}
        </Modal>
    )
};

CorporateModal.propTypes = {
    toShow: PropTypes.bool.isRequired,
    modalType: PropTypes.string.isRequired,
    title: PropTypes.string,
    body: PropTypes.any,
    modalClosed: PropTypes.func.isRequired
}

export default CorporateModal
